import { useEffect, useRef, useState } from 'react';
import { heroVideo, smallHeroVideo } from '../utils';

const SmoothVideo = ({ IsMobile, isInView }) => {
  const HeroVideoRef = useRef(null);
  const [videoSrc, setVideoSrc] = useState(
    IsMobile ? smallHeroVideo : heroVideo
  );
  useEffect(() => {
    if (!isInView) return;
    setVideoSrc(IsMobile ? smallHeroVideo : heroVideo);
  }, [IsMobile]);

  // ✅ Restart video when it becomes visible again
  useEffect(() => {
    const video = HeroVideoRef.current;
    if (!video) return;

    if (isInView) {
      // Reset playback to start
      video.currentTime = 0;
      video.play().catch(() => {});
    } else {
      video.pause();
    }
  }, [isInView]);
  // useEffect(() => {
  //   const video = HeroVideoRef.current;
  //   if (!video || IsMobile) return;

  //   const loopSeconds = 2.7; // last N seconds to loop

  //   const handleEnded = () => {
  //     video.currentTime = Math.max(0, video.duration - loopSeconds);
  //     video.play();
  //   };

  //   video.addEventListener('ended', handleEnded);
  //   return () => video.removeEventListener('ended', handleEnded);
  // }, [IsMobile]);

  useEffect(() => {
    const video = HeroVideoRef.current;
    if (!video) return;

    if (isInView) {
      video.play().catch(() => {});
    } else {
      video.pause();
    }
  }, [isInView]);

  return (
    <video
      muted
      playsInline
      autoPlay
      key={videoSrc}
      preload="auto"
      poster={
        IsMobile
          ? `${import.meta.env.BASE_URL}assets/images/mobilePoster.webp`
          : `${import.meta.env.BASE_URL}assets/images/poster.webp`
      }
      ref={HeroVideoRef}
      className="tilt"
      crossOrigin="anonymous"
      // loading="eager"
      // fetchPriority="high"
    >
      <source src={videoSrc} type="video/webm" />
    </video>
  );
};

export default SmoothVideo;
